module.exports = __webpack_public_path__ + "img/L_317_0.88dd9b16.png";